import { pxToRem } from '../../utils';
var chatStyles = {
    root: function (_a) {
        var v = _a.variables;
        return ({
            backgroundColor: v.backgroundColor,
            border: "1px solid " + v.backgroundColor,
            display: 'flex',
            flexDirection: 'column',
            listStyle: 'none',
            padding: "0 " + pxToRem(10) + " 0 " + pxToRem(10),
            margin: 0,
        });
    },
};
export default chatStyles;
